module.exports = __webpack_public_path__ + "mobile-app_rb___2H9Le.png";